const round = (value) => Math.round((value + Number.EPSILON) * 10000) / 10000;

export function markupPercent(cost, sale) {
  return Number(cost) > 0 ? round((Number(sale || 0) / Number(cost) - 1) * 100) : null;
}

export function saleFromMarkup(cost, markup) {
  return round(Number(cost) * (1 + Number(markup || 0) / 100));
}

export async function lookupRecipeSalePrice(api, contactId, partId, cost) {
  const contact = contactId ? (await api.get(`/contacte/${contactId}`)).data : null;
  const catalogId = contact?.bxcatalog_id;
  try {
    let response;
    if (catalogId) {
      try {
        response = await api.get("/pret-catalog/lookup", {
          params: { catalog_id: catalogId, bxpart_id: partId },
        });
      } catch (error) {
        if (error.response?.status !== 404) throw error;
      }
    }
    if (!response) {
      response = await api.get("/pret-catalog/lookup", { params: { bxpart_id: partId } });
    }
    const { data } = response;
    if (data.valuta_cod && data.valuta_cod.toUpperCase() !== "RON") {
      throw new Error("Prețul din catalog este în altă valută. Introduceți prețul de vânzare în lei.");
    }
    return data.pret == null ? cost : Number(data.pret);
  } catch (error) {
    if (error.response?.status === 404) return cost;
    throw error;
  }
}
